import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedinIn, faGithub } from '@fortawesome/free-brands-svg-icons';

export default function Footer() {
  const linkedin = <FontAwesomeIcon icon={faLinkedinIn} />;
  const github = <FontAwesomeIcon icon={faGithub} />;
  return (
    <div className="final">
      <div>
        <a
          className="link"
          href={'https://www.linkedin.com/in/irinagastmaier/'}
          title="in/irinagastmaier"
          alt="linkedin"
          target="_blank"
          rel="noopener noreferrer"
        >
          {linkedin}
        </a>
        <a
          className="link"
          href={'https://github.com/irinagastmaier'}
          title="/irinagastmaier"
          alt="GitHub"
          target="_blank"
          rel="noopener noreferrer"
        >
          {github}
        </a>
      </div>
    </div>
  );
}
